
import React from 'react'; // Import React to create the component
import '../css/LoginPage.css';
import Footer from './Footer';
import SignUpNavbar from './SignUpNavbar';
import { Link } from 'react-router-dom';
const LoginPage = () => {
   const [email, setEmail] = React.useState('');
   const [password, setPassword] = React.useState('');
   const handleSubmit = (e) => {
        e.preventDefault();
        fetch('https://18.117.231.157/api/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email,
                password
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.message == "Success") {
                    alert(`Logged in as ${email}`);
                    console.log(data.user);
                    sessionStorage.setItem('user', JSON.stringify(data.user));
                    window.location.href = '/bmicalculator'; // Redirect to the workout dashboard
                    setEmail('');
                    setPassword('');
                } else {
                    console.log(data);
                    alert('Invalid email or password. Please try again.');
                }
            });
       
       
    }

    return (
        <div>
            <SignUpNavbar /> {/* Renders the navigation bar at the top of the page */}
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <h1 className='contactuspageheaders'>Login</h1>
            <br></br>
            <form className='loginform' onSubmit={handleSubmit}>
                <label htmlFor="username">Email</label>
                <input type="text" id="username" name="username"
                 onInvalid={(e) => e.target.setCustomValidity('Please enter a valid email address.')}
                 onChange = {(e) => setEmail(e.target.value)}
                 onInput={(e) => e.target.setCustomValidity('')} required />

                <label htmlFor="password">Password</label>
                <input type="password" id="password" name="password"
                onInvalid={(e) => e.target.setCustomValidity('Please enter your password.')}
                onChange={(e) => setPassword(e.target.value)}
                onInput={(e) => e.target.setCustomValidity('')}  required />
                <Link className='forgotPassword' to="/forgotpassword" >Forgot Password?</Link>
              
                <button type="submit" className='loginbutton'>Login</button>
                
            </form>
            <div className='overlap'>
                <div className='main'><h1>New Here?</h1></div>
                <div className='sub'><h1>Sign Up<br></br>Now</h1></div>
            </div>
           

            <div className='signup'>
                            <Link className='signupbutton' to="/register" style={{ textAlign: 'center' }}>Sign Up</Link>
                        </div>
            <br>
            </br>
            <br></br>
            <br></br>
            <br></br>
            <Footer/> {/* Renders the footer at the bottom of the page */}
        </div>
    );
};

export default LoginPage; // Export the AboutUs component so it can be used in other parts of the app
